import React from "react";
import useSaveBarStore from "@/stores/useSaveBarStore";

const ContextualSaveBar = () => {
  const { isVisible, onSave, onDiscard } = useSaveBarStore();

  // Do not show anything if there is no changes
  if (!isVisible) return null;

  return (
      <div className="flex flex-row items-center justify-between w-[40%] bg-gradient-to-b from-[#ffffff] to-[#edf2f9] dark:bg-[#000] border border-gray-200 dark:border-white/20 px-5 py-2 rounded-[10px] shadow-md transition">
        <div>
          <span className="text-[14px] font-semibold text-[#000] dark:text-white">Unsaved changes</span>
        </div>

        <div className="flex gap-1">
          <button
            onClick={onDiscard}
            className="text-sm px-3 py-1 rounded-[8px] border font-semibold border-gray-300 dark:border-white/30 hover:bg-gray-100 dark:hover:bg-white/10"
          >
            Discard
          </button>

          <button
            onClick={onSave}
            className="text-sm px-4 py-1 rounded-[8px] bg-[#000] font-semibold text-white hover:bg-gray-800"
          >
            Save
          </button>
        </div>
      </div>
  );
};

export default ContextualSaveBar;